export default "__VITE_ASSET__BQpoXJum__"